import { useEffect } from "react";

const CookiePolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page" data-testid="cookie-policy-page">
      <div className="legal-container">
        <h1 className="legal-title">Cookie Policy</h1>
        <p className="legal-updated">Last Updated: 5th March 2026</p>

        <p className="legal-intro">
          This Cookie Policy explains how AMATYA, operated by ANS Legal and Business Services LLP, uses cookies and similar technologies when you visit www.amatya.co.in or use the associated mobile applications (collectively referred to as the "Platform"). By continuing to browse or use our Platform, you agree to the use of cookies as described in this policy.
        </p>

        <section className="legal-section">
          <h2>1. What Are Cookies</h2>
          <p>Cookies are small text files stored on your device when you visit a website. They help websites remember information about your visit, such as:</p>
          <ul>
            <li>Login sessions</li>
            <li>User preferences</li>
            <li>Browsing behavior</li>
            <li>Device information</li>
          </ul>
          <p>Cookies allow websites to function efficiently and improve the user experience.</p>
        </section>

        <section className="legal-section">
          <h2>2. Types of Cookies We Use</h2>
          
          <h3>Essential Cookies</h3>
          <p>These cookies are necessary for the basic functioning of the Platform. They help with:</p>
          <ul>
            <li>User authentication</li>
            <li>Secure login</li>
            <li>Service booking functionality</li>
            <li>Navigation across pages</li>
          </ul>
          <p>Without these cookies, certain services may not function properly.</p>

          <h3>Performance Cookies</h3>
          <p>These cookies collect information about how visitors use the Platform. They help us understand:</p>
          <ul>
            <li>Which pages are most visited</li>
            <li>How users navigate the website</li>
            <li>Technical errors or issues</li>
          </ul>
          <p>This information helps us improve website performance.</p>

          <h3>Functional Cookies</h3>
          <p>These cookies remember user preferences such as:</p>
          <ul>
            <li>Language selection</li>
            <li>Login information</li>
            <li>Customized user settings</li>
          </ul>
          <p>They enhance the overall user experience.</p>

          <h3>Advertising and Analytics Cookies</h3>
          <p>These cookies may be used by third-party service providers such as:</p>
          <ul>
            <li>Google Analytics</li>
            <li>Social media platforms</li>
            <li>Advertising networks</li>
          </ul>
          <p>They help measure marketing effectiveness and deliver relevant advertisements.</p>
        </section>

        <section className="legal-section">
          <h2>3. Third-Party Cookies</h2>
          <p>Some cookies may be placed by third-party service providers. These providers may use cookies to:</p>
          <ul>
            <li>Analyze website traffic</li>
            <li>Provide analytics services</li>
            <li>Deliver targeted advertisements</li>
          </ul>
          <p>AMATYA does not control these cookies and recommends reviewing the privacy policies of such third parties.</p>
        </section>

        <section className="legal-section">
          <h2>4. Managing Cookies</h2>
          <p>Most web browsers allow you to control cookies through browser settings. You can:</p>
          <ul>
            <li>Delete cookies</li>
            <li>Block cookies</li>
            <li>Receive alerts when cookies are being used</li>
          </ul>
          <p>However, disabling cookies may affect the functionality of certain parts of the Platform.</p>
        </section>

        <section className="legal-section">
          <h2>5. Data Collected Through Cookies</h2>
          <p>Cookies may collect information such as:</p>
          <ul>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device type</li>
            <li>Pages visited</li>
            <li>Time spent on pages</li>
            <li>Interaction with services</li>
          </ul>
          <p>This data helps improve the Platform and personalize user experience.</p>
        </section>

        <section className="legal-section">
          <h2>6. Updates to this Cookie Policy</h2>
          <p>AMATYA reserves the right to update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
        </section>

        <section className="legal-section">
          <h2>7. Contact Information</h2>
          <p>If you have any questions regarding this Cookie Policy, please contact:</p>
          <div className="legal-contact">
            <p><strong>ANS Legal and Business Services LLP</strong></p>
            <p>C-209, M3M Urbana</p>
            <p>Sector 67, Gurgaon – 122101</p>
            <p>Haryana, India</p>
            <p><strong>Email:</strong> care@amatya.co.in</p>
            <p><strong>Phone:</strong> +91 9711767167</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
